export default __webpack_public_path__ + "static/WBW-logo-colored-745e8021f448c5c53c666821343937f3.svg";